import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus } from '../../enum';

@Component({
  selector: 'app-add-update-resource',
  templateUrl: './add-update-resource.component.html',
  styleUrls: ['./add-update-resource.component.scss'],

  standalone: false,
})
export class AddUpdateResourceComponent {
  isVisibleresourceDrawer = true;
  resourceDrawerTitle = 'Add Resource';
  isLoadingUpload = false;
  isLoadingOne = false;
  darkColorStyle: any;
  lightColorValidationColor: any;
  darkColorValidationColor: any;
  lightColorStyle: any;
  uploadResult: any = null;
  uploadFlag: any = false;
  @Output() hideResourceDrawer = new EventEmitter();
  @Input() selectedResourceData: any;
  @Input() resourceType: any;
  url: any;
  deleteIcon: any;
  userDetails: any;

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.resourceForm_fb();
  }

  ngOnInit(): void {
    if (this.selectedResourceData != null) {
      this.resourceDrawerTitle =
        'Edit Resource (' + this.selectedResourceData.displayName + ')';
      this._fS.resourceForm.patchValue({
        resourceName: this.selectedResourceData.displayName,
        link: this.selectedResourceData.url,
      });
      this.lightColorStyle = this._fS.resourceForm.value.color;
    }
  }

  //cancel update Agency
  handleCancel(data?: any) {
    this.isVisibleresourceDrawer = false;
    this.hideResourceDrawer.emit({
      hide: this.isVisibleresourceDrawer,
      data: data ? data : null,
    });
  }

  //add/update Agency
  handleOk() {
    if (this._fS.resourceForm.valid) {
      const formValue = this._fS.resourceForm.value;
      var resournceBody = {
        id:
          this.selectedResourceData != null
            ? this.selectedResourceData.id
            : null,
        displayName: formValue.resourceName.trim(),
        url: formValue.link,
        status: formValue.link ? 1 : 0,
        resourceType: this.resourceType
        // Status: formValue.isActiveagency == true ? 1 : 0,
      };
      if (this.selectedResourceData) {
        this.updateResourceData(resournceBody);
      } else {
        this.addResourceData(resournceBody);
      }
    } else {
      //to fire validations on invalid fields
      Object.values(this._fS.resourceForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  //api call to add/update agency
  updateResourceData(resourceBody: any) {
    this.isLoadingOne = true;
    // resourceBody = JSON.stringify(resourceBody)
    this._cpS.UpdateResource(resourceBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);

        this.handleCancel(response.result);
        this.isLoadingOne = false;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }
  //api call to add/update agency
  addResourceData(resourceBody: any) {
    this.isLoadingOne = true;
    // resourceBody = JSON.stringify(resourceBody)
    this._cpS.AddResouce(resourceBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);

        this.handleCancel(response.result);
        this.isLoadingOne = false;
      } else {
        this._cS.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }
}
